import { createFileRoute } from "@tanstack/react-router";

import CheckoutPage from "./-components/CheckoutPage";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/customize/checkout"
)({
  component: CheckoutPage,
});
